import { gql } from '@apollo/client';
import { ErrorMessageInfo, WarrantyInfoShared } from '../fragments';

export default gql`
  mutation updateWarranty($input: WarrantyAdminUpdateInput!) {
    updateWarranty(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warranty {
        ...WarrantyInfoShared
      }
    }
  }
  ${WarrantyInfoShared}
  ${ErrorMessageInfo}
`;
